// extracted by mini-css-extract-plugin
export var baseButton = "_w5-0";
export var controlsArrowKeys = "_w5-1";
export var controlsResetButton = "_w5-2";
export var lightGameButton = "_w5-4 _w5-0";
export var playAgainButton = "_w5-5 _w5-0";
export var startGameButton = "_w5-3 _w5-0";